import React, { useState } from "react";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { useResizeObserver } from "../../../../../../common/hooks";
import { translate } from "../../../../../../common/providers";
import { icon, IconComponent } from "../../../../../../common/components";
import VersioningDocumentList from "./VersioningDocumentList";
import styles from "./VersioningDocumentTree.module.css";

const VersioningDocumentTree = ({ documents, hasSearch = false, mode, onCheck, onToggleExpand, selectedDocId }) => {
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [containerRef, size] = useResizeObserver();
	const handleCheck = (document) => {
		setSelectedRowId(document.id);
		onCheck(document);
	};
	return (
		(documents.filter((doc) => doc.count === undefined || doc.count < 1000).length === 0 && (
			<div className={styles.empty}>
				{hasSearch
					? translate("common:filters.document-tree.no-documents-search")
					: translate("common:filters.document-tree.no-documents")}
			</div>
		)) || (
			<>
				{documents.some((doc) => doc.count >= 1000) && (
					<div className={styles.infoBox}>
						<IconComponent className={styles.infoIcon} icon={icon.faInfoCircle} />
						<span>{translate("common:filters.document-tree.too-many-documents")}</span>
					</div>
				)}
				<div ref={containerRef} className={styles.container}>
					{isNonEmptyArray(documents) && (
						<VersioningDocumentList
							containerWidth={size.width}
							documents={documents.filter((doc) => doc.count === undefined || doc.count < 1000)}
							mode={mode}
							selectedDocId={selectedDocId}
							selectedRowId={selectedRowId}
							onCheck={handleCheck}
							onToggleExpand={onToggleExpand}
						/>
					)}
				</div>
			</>
		)
	);
};

export default VersioningDocumentTree;
